import { render, staticRenderFns } from "./Summarizeorderrevisionrecords.vue?vue&type=template&id=0183819c&scoped=true"
import script from "./Summarizeorderrevisionrecords.vue?vue&type=script&lang=js"
export * from "./Summarizeorderrevisionrecords.vue?vue&type=script&lang=js"
import style0 from "./Summarizeorderrevisionrecords.vue?vue&type=style&index=0&id=0183819c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0183819c",
  null
  
)

export default component.exports